import React, { useEffect, useState } from "react";
import {
  StyledCircle,
  StyledRadioButton,
  StyledRadioGroupWrapper,
  StyledRadioLabel,
  StyledRadioWrapper,
} from "../styles/styledComponents";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { useSelectedContextState } from "../context/selectedContext";

type RadioGroupProps = {
  type: string;
  selected: (value: string) => any;
  radioValues: any[];
  setFirstDefaultValue?: boolean;
};

const RadioGroup = (props: RadioGroupProps) => {
  const _handleKeyDown = (e: any, id: any) => {
    if (e.key === "Enter" || e.keyCode === 32) {
      setSelectedValue(id.toString());
      selected(id.toString());
    }
  };
  const [state, dispatch] = useSelectedContextState();
  const [selectedValue, setSelectedValue] = useState("");
  let { selected, radioValues, setFirstDefaultValue, type } = props;
  const { clearAll, clearChildrenStates } = state;

  useEffect(() => {
    if (radioValues.length > 0) {
      setSelectedValue("");
    }
  }, [radioValues]);

  useEffect(() => {
    if (
      setFirstDefaultValue &&
      radioValues.length > 0 &&
      selectedValue === ""
    ) {
      setSelectedValue(radioValues[0].id.toString());
      selected(radioValues[0].id.toString());
    }
  }, [radioValues, selected, selectedValue, setFirstDefaultValue]);

  useEffect(() => {
    if (clearAll || (clearChildrenStates && type.toLowerCase() !== "product")) {
      setSelectedValue("");
    }
  }, [clearAll, clearChildrenStates, type]);

  const onChange = (event: any) => {
    setSelectedValue(event.target.value);
    selected(event.target.value);

    if (type.toLowerCase() === "product") {
      dispatch({ type: "setClearChildrenStates", payload: true });
    }
  };

  return (
    <StyledRadioGroupWrapper role="radiogroup">
      {radioValues.map((item, index) => (
        <StyledRadioWrapper
          key={item.id}
          role="radio"
          aria-labelledby={item.id + "label"}
          aria-checked={selectedValue === item.id.toString()}
        >
          <StyledRadioButton
            type="radio"
            name={item.name}
            id={item.id + item.name}
            value={item.id}
            onChange={onChange}
            checked={selectedValue === item.id.toString()}
          />
          <StyledRadioLabel
            id={item.id + "label"}
            tabIndex={0}
            onKeyDown={(e) => _handleKeyDown(e, item.id)}
            htmlFor={item.id + item.name}
          >
                  <StyledCircle>
                      <span>
                      <FontAwesomeIcon
                          icon={faCheck}
                          color="black"
                          size="sm"
                          style={{
                              position: "absolute",
                              marginLeft: "5px",
                              marginTop: "4px",
                              display:
                                  selectedValue === item.id.toString() ? "block" : "none",
                          }}
                          />
                          </span>
            </StyledCircle>
            {item.name}
          </StyledRadioLabel>
        </StyledRadioWrapper>
      ))}
    </StyledRadioGroupWrapper>
  );
};

export default RadioGroup;
